import { StringUtils } from 'src/app/services/utils/string.utils';
import { isNullOrUndefined } from 'util';
import { CharacteristicObject } from 'src/app/models/characteristics/characteristic/characteristic-object.model';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
export class TaskDetailsProductObject {

  private name: string;
  private characteristics: CharacteristicsObject;

  constructor(private action: string, name: string, private id: string, private information: boolean) {
    this.name = !isNullOrUndefined(name) ? name : '';
    this.characteristics = null;
  }

  public static create(): TaskDetailsProductObject {
    return new TaskDetailsProductObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
      StringUtils.NOT_AVALIABLE, false);
  }

  public getAction(): string {
    return this.action;
  }

  public getName(): string {
    return this.name;
  }

  public getId(): string {
    return this.id;
  }

  public getCharacteristics(): CharacteristicsObject {
    return this.characteristics;
  }

  public getNumberOfCharacteristics(): number {
    return this.characteristics.inputCharacteristics.length + this.characteristics.outputCharacteristics.length;
  }

  public setCharacteristics(characteristics: CharacteristicsObject): void {
    this.characteristics = characteristics;
  }

  public hasInformation(): boolean {
    return this.information;
  }
}
